import { enhancedFormateTimeStamp } from '@/common/utils';
import Copy from '@/components/copy';
import { Drawer, Button, Table, Space, message, Form, Modal, Input, Tooltip } from '@drip/drip-design';
import React, { useState, useEffect } from 'react';
import HeaderInfo from '@/components/SpacialListConfig/headerInfo';
import ListConfigEdit from '@/components/SpacialListConfig/manage/listConfigEdit';
import { queryList, bindActivity } from '../../apis';
import AuthManage from '../authManage';
import AuthDistribute from '../authDistribute';
import './index.less';
import ComponentLog from '@/components/component-log';
import { useGetAuthRole } from '@/components/SpacialListConfig/getAuthRole';
interface propsType {
  businessType: number;
  businessId?: string;
  visible: boolean;
  setVisible: any;
  title?: string;
  descriptionList?: Array<{ key: string; value: string }>;
  planCode?: string;
  lineType?: string;
}

const ListManage: React.FC<propsType> = (props) => {
  const { businessType, businessId, visible, setVisible, title, descriptionList, planCode, lineType } = props;
  const [conditions, setConditions] = useState({ currentPage: 1, pageSize: 10 });
  const [list, setList] = useState({
    list: [],
    totalCount: 0,
  });

  const { isPartner, isManage, isApplicant } = useGetAuthRole({
    businessType,
    businessId,
    planCode,
  });

  useEffect(() => {
    if (!visible) return;
    queryList({ ...conditions, businessId, businessType, planCode })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '白名单列表请求失败';
        setList(data);
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [conditions, visible, businessId, businessType, planCode]);

  const freshList = () => {
    setConditions({ ...conditions });
  };

  const openApplyList = (id: number) => {
    //@ts-ignore
    window?.ACORE?.openWhiteListDrawer?.showApply({
      title,
      descriptionList,
      planCode,
      businessType,
      businessId,
      isManagerOpenAppliedList: true,
      whiteTemplateId: id,
    });
  };

  const columns = [
    {
      title: '白名单信息',
      fixed: 'left',
      width: '300px',
      render(record: any) {
        const { whiteName, id } = record;
        return (
          <div>
            <Tooltip title={whiteName}>
              <div className="ellipsis-1-line">{whiteName}</div>
            </Tooltip>
            <div className="grey" style={{ fontSize: 12 }}>
              编号：<Copy text={id}>{id}</Copy>
            </div>
          </div>
        );
      },
    },
    {
      title: '白名单类型',
      render(record: any) {
        const { permissionName } = record;
        return permissionName;
      },
    },
    {
      title: '所属活动',
      render(record: any) {
        const { businessId: inner_businessId, businessName, id, isBindActivity } = record;
        if (!inner_businessId) {
          return (
            <div>
              <div>待绑定</div>
              {isBindActivity ? (
                <BindActivityIdModal id={id} businessType={businessType} freshList={freshList}>
                  <a>去绑定</a>
                </BindActivityIdModal>
              ) : null}
            </div>
          );
        }
        return (
          <div>
            <div>{businessName}</div>
            <div>
              活动ID：<Copy text={inner_businessId}>{inner_businessId}</Copy>
            </div>
          </div>
        );
      },
      hidden: businessId,
    },
    {
      title: '白名单申请时间',
      hidden: [3].includes(businessType), //开放报名没有
      render(record: any) {
        const { applyBeginTime, applyEndTime } = record;
        return (
          <>
            <div>
              <span className="grey">开始时间：</span>
              {enhancedFormateTimeStamp(applyBeginTime, 'YY-MM-DD hh:mm:ss')}
            </div>
            <div>
              <span className="grey">结束时间：</span>
              {enhancedFormateTimeStamp(applyEndTime, 'YY-MM-DD hh:mm:ss')}
            </div>
          </>
        );
      },
    },
    {
      title: '白名单生效时间',
      hidden: ![3].includes(businessType), // 开放报名有
      render(record: any) {
        const { effectiveBeginTime, effectiveEndTime } = record;
        return (
          <>
            <div>
              <span className="grey">开始时间：</span>
              {enhancedFormateTimeStamp(effectiveBeginTime, 'YY-MM-DD hh:mm:ss')}
            </div>
            <div>
              <span className="grey">结束时间：</span>
              {enhancedFormateTimeStamp(effectiveEndTime, 'YY-MM-DD hh:mm:ss')}
            </div>
          </>
        );
      },
    },
    {
      title: '创建/更新时间',
      render(record: any) {
        const { createErp, createTime, updateTime } = record;
        return (
          <>
            <div>
              <span className="grey">创建人：</span>
              {createErp}
            </div>
            <div>
              <span className="grey">创建时间：</span>
              {enhancedFormateTimeStamp(createTime, 'YY-MM-DD hh:mm:ss')}
            </div>
            <div>
              <span className="grey">更新时间</span>：{enhancedFormateTimeStamp(updateTime, 'YY-MM-DD hh:mm:ss')}
            </div>
          </>
        );
      },
    },
    {
      title: '操作',
      width: '180px',
      fixed: 'right',
      render(record: any) {
        const { operateList = [], id } = record;
        return (
          <Space wrap={true}>
            {operateList.includes(1) && (
              <AuthManage id={id}>
                <ComponentLog clstag="yx_whiteapply_page_1706591686206|8">
                  <a>权限管理</a>
                </ComponentLog>
              </AuthManage>
            )}
            {operateList.includes(2) && (
              <AuthDistribute id={id} isPartner={isPartner}>
                <ComponentLog clstag="yx_whiteapply_page_1706591686206|9">
                  <a>权限分配</a>
                </ComponentLog>
              </AuthDistribute>
            )}
            {operateList.includes(3) && (
              <ListConfigEdit
                id={id}
                isEdit={true}
                businessType={businessType}
                freshList={freshList}
                businessId={businessId}
                lineType={lineType}
              >
                <a>编辑</a>
              </ListConfigEdit>
            )}
            {operateList.includes(4) && (
              <ComponentLog clstag="yx_center_seckill_manage_1700464033799|36">
                <a onClick={() => openApplyList(id)}>申请记录</a>
              </ComponentLog>
            )}
          </Space>
        );
      },
    },
  ].filter((ele) => !ele.hidden);

  return (
    <>
      <Drawer
        width={1200}
        visible={visible}
        title="白名单管理"
        onClose={() => {
          setVisible(false);
        }}
        className="spacial-list-manage-list"
      >
        {Boolean(title) && <HeaderInfo title={title} descriptionList={descriptionList} />}
        <div className="table-header">
          <h4>可申请白名单</h4>
          {businessId && (isPartner || isManage || isApplicant) ? null : ( // 没有businessId（逆向流程）的话，就直接展示，否则还要判断角色
            <ListConfigEdit
              businessType={businessType}
              businessId={businessId}
              freshList={freshList}
              lineType={lineType}
            >
              <Button type="primary">新建白名单</Button>
            </ListConfigEdit>
          )}
        </div>
        <Table
          //@ts-ignore
          columns={columns}
          scroll={{ x: 'max-content' }}
          dataSource={list.list}
          pagination={{
            hideOnSinglePage: true,
            total: list.totalCount,
            pageSize: conditions.pageSize,
            current: conditions.currentPage,
            onChange(page) {
              setConditions({ ...conditions, currentPage: page });
            },
          }}
        />
      </Drawer>
    </>
  );
};

function BindActivityIdModal(props: any) {
  const { id, businessType, freshList } = props;
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const btn = React.cloneElement(props.children, {
    onClick: () => setVisible(true),
  });
  const onCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onFinish = (val: { businessId: string }) => {
    bindActivity({ ...val, id, businessType })
      .then((res) => {
        const { ret, msg } = res;
        if (ret !== '0') throw msg || '绑定活动失败';
        message.success('绑定成功！');
        onCancel();
        freshList();
      })
      .catch((ex) => {
        message.error(ex);
      });
  };
  return (
    <>
      {btn}
      <Modal
        title="活动绑定"
        okText="确认绑定"
        onCancel={onCancel}
        visible={visible}
        onOk={() => form.submit()}
        width={600}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            label={
              <span>
                绑定白名单所属活动
                <span style={{ color: ' #D96500' }}>（活动发布前绑定有效，绑定后不可更改，请谨慎操作）</span>
              </span>
            }
            name="businessId"
            rules={[
              {
                required: true,
                message: '请填写活动id',
              },
            ]}
          >
            <Input placeholder="请输入主题活动ID或主题活动下预售活动ID" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default ListManage;
